/**
 * Version-sensitive entry point for the clinician app.
 *
 * Only this tiny chunk (and its counterpart, public-jan-bootstrap.ts) embeds
 * the compile-time `__APP_VERSION__`/`__APP_RELEASE_DATE__` constants. It
 * mirrors them onto `window` for the many runtime call sites (axios
 * interceptors, settings page, recording metadata, New Relic, Sentry, etc.)
 * that read `window.APP_VERSION`, then dynamically imports the actual
 * application module (src/index.tsx).
 *
 * Because nothing in the application module graph imports these compile-time
 * constants directly, a version-only release only changes this bootstrap
 * chunk (and sw.js) — the application and lazy route chunks keep identical
 * content hashes across releases, so browsers and the service worker's
 * precache don't need to re-download them.
 */
import { importAppOrReload } from "./lib/bootstrapImport";

window.APP_VERSION = __APP_VERSION__;
window.APP_RELEASE_DATE = __APP_RELEASE_DATE__;

void importAppOrReload(() => import("./index"));
